var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useReducer, useState } from 'react';
export var SubscriberActionType;
(function (SubscriberActionType) {
  SubscriberActionType["SET_SUBSCRIBER"] = "SET_SUBSCRIBER";
  SubscriberActionType["SET_COINSURANCE"] = "SET_COINSURANCE";
  SubscriberActionType["SET_BENFREQUENCIES"] = "SET_BENFREQUENCIES";
  SubscriberActionType["SET_CLAIMSINFO"] = "SET_CLAIMSINFO";
  SubscriberActionType["SET_ELIGIBILITY"] = "SET_ELIGIBILITY";
  SubscriberActionType["UNEXPECTED"] = "UNEXPECTED";
  SubscriberActionType["CLEAR"] = "CLEAR";
})(SubscriberActionType || (SubscriberActionType = {}));
export var MemberActionType;
(function (MemberActionType) {
  MemberActionType["SET_CURRENT_MEMBER"] = "SET_CURRENT_MEMBER";
  MemberActionType["SET_SERVICEHISTORY"] = "SET_SERVICEHISTORY";
})(MemberActionType || (MemberActionType = {}));
export var MemberSearchContext = /*#__PURE__*/createContext({
  subscriber: undefined,
  subscriberDispatch: function () {},
  currentMember: undefined,
  currentMemberDispatch: function () {},
  loadingMemberSearch: false,
  setMemberSearchLoading: function () {},
  memberSearchError: false,
  setMemberSearchError: function () {},
  procedureCodeSearchResults: [],
  setProcedureCodeSearchResults: function () {},
  treatmentHistorySearchResults: [],
  setTreatmentHistorySearchResults: function () {}
});
var MemberSearchProvider = function (_a) {
  var children = _a.children;
  var _b = useState(false),
    loadingMemberSearch = _b[0],
    setMemberSearchLoading = _b[1];
  var _c = useState(false),
    memberSearchError = _c[0],
    setMemberSearchError = _c[1];
  var _d = useState([]),
    procedureCodeSearchResults = _d[0],
    setProcedureCodeSearchResults = _d[1];
  var _e = useState([]),
    treatmentHistorySearchResults = _e[0],
    setTreatmentHistorySearchResults = _e[1];
  function memberReducer(member, action) {
    switch (action.type) {
      case MemberActionType.SET_CURRENT_MEMBER:
        setProcedureCodeSearchResults([]);
        setTreatmentHistorySearchResults([]);
        return action.currentMemberPayload;
      case MemberActionType.SET_SERVICEHISTORY:
        if (!!member) {
          return __assign(__assign({}, member), {
            serviceHistory: action.serviceHistory
          });
        } else {
          throw new Error('Cannot add service history without a subscriber set');
        }
      default:
        throw new Error('Invalid Subscriber Action');
    }
  }
  function subscriberReducer(subscriber, action) {
    switch (action.type) {
      case SubscriberActionType.SET_SUBSCRIBER:
        return action.subscriberPayload;
      case SubscriberActionType.SET_COINSURANCE:
        if (!!subscriber) {
          return __assign(__assign({}, subscriber), action.coinsurancePayload);
        } else {
          throw new Error('Cannot add coinsurance information without a subscriber set');
        }
      case SubscriberActionType.SET_BENFREQUENCIES:
        if (!!subscriber) {
          return __assign(__assign({}, subscriber), action.benefitAndFrequencyPayload);
        } else {
          throw new Error('Cannot add benefit & frequency information without a subscriber set');
        }
      case SubscriberActionType.SET_CLAIMSINFO:
        if (!!subscriber) {
          return __assign(__assign({}, subscriber), action.claimsInfo);
        } else {
          throw new Error('Cannot add claims info without a subscriber set');
        }
      case SubscriberActionType.SET_ELIGIBILITY:
        if (!!subscriber) {
          return __assign(__assign({}, subscriber), action.eligibilityPayload);
        } else {
          throw new Error('Cannot add eligibility info without a subscriber set');
        }
      default:
        throw new Error('Invalid Subscriber Action');
    }
  }
  var _f = useReducer(memberReducer, undefined),
    currentMember = _f[0],
    currentMemberDispatch = _f[1];
  var _g = useReducer(subscriberReducer, undefined),
    subscriber = _g[0],
    subscriberDispatch = _g[1];
  return _jsx(MemberSearchContext.Provider, __assign({
    value: {
      subscriber: subscriber,
      subscriberDispatch: subscriberDispatch,
      currentMember: currentMember,
      currentMemberDispatch: currentMemberDispatch,
      loadingMemberSearch: loadingMemberSearch,
      setMemberSearchLoading: setMemberSearchLoading,
      memberSearchError: memberSearchError,
      setMemberSearchError: setMemberSearchError,
      procedureCodeSearchResults: procedureCodeSearchResults,
      setProcedureCodeSearchResults: setProcedureCodeSearchResults,
      treatmentHistorySearchResults: treatmentHistorySearchResults,
      setTreatmentHistorySearchResults: setTreatmentHistorySearchResults
    }
  }, {
    children: children
  }));
};
export default MemberSearchProvider;